import { LoaderFunction } from "react-router-dom";
import { fetchAlgorithm } from "./queries";

export const loader: LoaderFunction = async ({ params }) => {
  return {
    data: params.algorithmId ? await fetchAlgorithm(params.algorithmId) : null,
  };
};
